import { Chip, Grid } from "@material-ui/core";
import cloneDeep from "lodash/cloneDeep";
import MaterialTable from "material-table";
import React, { useState } from "react";
import { BoxCard, PageLayout } from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import { Collections } from "api/model/Collections";
import { useCollection } from "api/hooks/useCollection";
import { Season } from "../../../api";
import { SeasonForm } from "./SeasonForm";
import { green, red } from "@material-ui/core/colors";
import { DateTime } from "luxon";

const Seasons = () => {
    const [seasonEditing, setSeasonEditing] = useState<Season | undefined>();
    const seasons =
        useCollection<Season[]>(
            {
                collection: Collections.SEASONS,
            },
            true
        ) || [];

    seasons.sort(
        (s1, s2) =>
            DateTime.fromISO(s2.endAt).toMillis() -
            DateTime.fromISO(s1.endAt).toMillis()
    );

    return (
        <PageLayout
            title="Temporadas"
            boxCardProps={{ padding: 0 }}
            showInBoxCard={false}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <SeasonForm
                        season={seasonEditing}
                        onCancel={() => setSeasonEditing(undefined)}
                        onSave={() => setSeasonEditing(undefined)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MaterialTable
                        components={{ Container: BoxCard }}
                        columns={[
                            {
                                field: "name",
                                title: "Nome",
                                render: (season) => {
                                    return `${season.name} | ${season.year}`;
                                },
                            },
                            {
                                field: "current",
                                title: "Atual",
                                render: (season) => {
                                    if (season.current) {
                                        return (
                                            <Chip
                                                label="Sim"
                                                style={{
                                                    backgroundColor:
                                                        green["500"],
                                                    color: "white",
                                                }}
                                            />
                                        );
                                    }
                                    return "Não";
                                },
                            },
                            {
                                field: "startAt",
                                title: "Inicia em",
                                render: (season) =>
                                    DateTime.fromISO(season.startAt).toFormat(
                                        "dd/MM/yyyy"
                                    ),
                            },
                            {
                                field: "endAt",
                                title: "Termina em",
                                render: (season) =>
                                    DateTime.fromISO(season.endAt).toFormat(
                                        "dd/MM/yyyy"
                                    ),
                            },
                        ]}
                        data={cloneDeep(seasons)}
                        actions={[
                            {
                                icon: "edit",
                                tooltip: "Editar",
                                onClick: (event, rowData) =>
                                    setSeasonEditing(rowData as Season),
                            },
                        ]}
                        options={{
                            paging: false,
                            toolbar: false,
                            rowStyle: (data) => {
                                const row = data as Season;
                                if (row.id === seasonEditing?.id) {
                                    return {
                                        backgroundColor: red["100"],
                                    };
                                }
                                return {};
                            },
                        }}
                        localization={LocalizationPTBr}
                    />
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export { Seasons };
